import { render, staticRenderFns } from "./ChannelBalanceLogs.vue?vue&type=template&id=67137ead&"
import script from "./ChannelBalanceLogs.vue?vue&type=script&lang=ts&"
export * from "./ChannelBalanceLogs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ChannelBalanceLogs.vue"
export default component.exports